import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Enable axe a11y checks in development
if (import.meta.env.DEV) {
  import('./utils/axe').then(m => m.setupAxe()).catch(() => {});
}

createRoot(document.getElementById("root")!).render(<App />);
